/**
 * Series collections: homepage cards that open a page of picture cards instead
 * of a Watch page, because their videos use different watch templates.
 *
 * Behind the Scenes and Beyond is the first. Two of its videos are episodes that
 * already live inside other series (HCBS episode 11, E-Prep episode 11), so their
 * cards open that series page at that episode. The other two are standalone
 * videos registered in singleVideos.js.
 *
 * Titles and durations are not repeated here. They are read at runtime from the
 * episode data file (episode items) or singleVideos.js (single items), so the
 * collection page always matches the page the card opens.
 *
 * Which languages a collection is available in comes from SERIES_AVAILABILITY
 * in languageConfig.js. Adding a language means adding it there and giving
 * every item below a `dataFiles` entry (episode items) and a `stills` entry for
 * that language. seriesCollections.test.js fails if one is missing.
 *
 * Item shapes:
 * - { type: 'episode', seriesSlug, episodeKey, dataFiles: { [lang]: file }, stills: { [lang]: path } }
 *   episodeKey is the key inside the data file's audience blocks, which both
 *   audiences share for these videos.
 * - { type: 'single', seriesSlug, stills: { [lang]: path } }
 */

import { SUPPORTED_LANGUAGES } from './translations';

const BEHIND_THE_SCENES_STILLS = '/assets/thumbnails/behind-the-scenes';

export const SERIES_COLLECTIONS = {
  'behind-the-scenes': {
    // Tracker order: Master Content Deliveries columns D to G.
    items: [
      {
        id: 'hcbs-behind-the-scenes',
        type: 'episode',
        seriesSlug: 'hcbs',
        episodeKey: '11',
        dataFiles: {
          [SUPPORTED_LANGUAGES.ENGLISH]: 'englishEpisodeData.json'
        },
        stills: {
          [SUPPORTED_LANGUAGES.ENGLISH]: `${BEHIND_THE_SCENES_STILLS}/english/HCBS_BTS_Still_ENG_V07.png`
        }
      },
      {
        id: 'mark-hamill-interview',
        type: 'episode',
        seriesSlug: 'emergency-preparedness',
        episodeKey: '11',
        dataFiles: {
          [SUPPORTED_LANGUAGES.ENGLISH]: 'englishEprepEpisodeData.json'
        },
        stills: {
          [SUPPORTED_LANGUAGES.ENGLISH]: `${BEHIND_THE_SCENES_STILLS}/english/PPM_EP002_Mark_Hamill_Still_ENG_V05.png`
        }
      },
      {
        id: 'artist-alex',
        type: 'single',
        seriesSlug: 'artist-alex',
        stills: {
          [SUPPORTED_LANGUAGES.ENGLISH]: `${BEHIND_THE_SCENES_STILLS}/english/PPM_EP003_Alex_Still_ENG_V05.png`
        }
      },
      {
        id: 'comic-distribution',
        type: 'single',
        seriesSlug: 'comic-distribution',
        stills: {
          [SUPPORTED_LANGUAGES.ENGLISH]: `${BEHIND_THE_SCENES_STILLS}/english/PPM_EP004_Comic_Still_ENG_V05.png`
        }
      }
    ]
  }
};

export function isSeriesCollection(slug) {
  return Object.prototype.hasOwnProperty.call(SERIES_COLLECTIONS, slug);
}
